module.exports = __webpack_public_path__ + "static/media/score_three.cee7fd1d.png";